import ScreeningPageContent from "@/app/(app)/screening/page";

export default function ScreeningPage() {
  return <ScreeningPageContent />;
}
